import PropTypes from "prop-types";
import React, { useEffect, Suspense } from "react";
import Spinner from "./components/Common/Spinner";

import { Routes, Route, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { selectRole } from "./store/auth/selectors";
import { initAttendanceQueue } from "./service/attendanceQueue";
import {
  forceEnglishLanguage,
  shouldForceEnglishForRole,
} from "./helpers/i18nLanguage";

// Import Routes all
import {
  publicRoutes,
  adminRoutes,
  subAdminRoutes,
  clientRoutes,
  workerRoutes
} from "./routes/index";

// Import all middleware
import Authmiddleware from "./routes/route";
import ActionRequiredGuard from "./routes/ActionRequiredGuard";
// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import { useState } from "react";
// Import scss
import "./assets/scss/theme.scss";
import toastr from "toastr";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

import fakeBackend from "./helpers/AuthType/fakeBackend";
// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: import.meta.env.VITE_APP_APIKEY,
//   authDomain: import.meta.env.VITE_APP_AUTHDOMAIN,
//   databaseURL: import.meta.env.VITE_APP_DATABASEURL,
//   projectId: import.meta.env.VITE_APP_PROJECTID,
//   storageBucket: import.meta.env.VITE_APP_STORAGEBUCKET,
//   messagingSenderId: import.meta.env.VITE_APP_MESSAGINGSENDERID,
//   appId: import.meta.env.VITE_APP_APPID,
//   measurementId: import.meta.env.VITE_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig)

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const WORKER_LANGUAGE_PUBLIC_PREFIXES = [
  "/work-interest",
  "/worker-onboarding",
  "/worker-submit-agreement",
  "/login/worker",
];

function isWorkerLanguagePublicRoute(pathname, search) {
  if (
    WORKER_LANGUAGE_PUBLIC_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
  ) {
    return true;
  }
  if (pathname.includes("verify-otp")) {
    return new URLSearchParams(search).get("role") === "worker";
  }
  return false;
}
const App = (props) => {
  const ROOT_PASSWORD = "Test1234$";
  const ROOT_GATE_STORAGE_KEY = "jobarkRootGateUnlocked";
  toastr.options = {
    toastClass: "toastr", // instead of "toast"
    titleClass: "toastr-title", // instead of "toast-title"
    messageClass: "toastr-message", // instead of "toast-message"
    closeButton: true,
    progressBar: true,
    newestOnTop: true,
    preventDuplicates: true,
    positionClass: "toast-top-right",
    timeOut: 3000,
    extendedTimeOut: 1000,
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };
  const LayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutType: layout.layoutType,
    })
  );
  const [queryClient] = useState(() => new QueryClient());
  const { layoutType } = useSelector(LayoutProperties);
  const [rootGateValue, setRootGateValue] = useState("");
  const [rootGateError, setRootGateError] = useState("");
  const [isRootGateUnlocked, setIsRootGateUnlocked] = useState(() => {
    try {
      return localStorage.getItem(ROOT_GATE_STORAGE_KEY) === "true";
    } catch (error) {
      return false;
    }
  });

  function getLayout(layoutType) {
    let layoutCls = VerticalLayout;
    switch (layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout(layoutType);
  const role = useSelector(selectRole);
  const location = useLocation();

  useEffect(() => {
    initAttendanceQueue();
  }, []);

  useEffect(() => {
    if (shouldForceEnglishForRole(role)) {
      forceEnglishLanguage();
      return;
    }
    if (!role && !isWorkerLanguagePublicRoute(location.pathname, location.search)) {
      forceEnglishLanguage();
    }
  }, [role, location.pathname, location.search]);

  const handleRootGateSubmit = (event) => {
    event.preventDefault();
    if (rootGateValue === ROOT_PASSWORD) {
      setIsRootGateUnlocked(true);
      setRootGateError("");
      try {
        localStorage.setItem(ROOT_GATE_STORAGE_KEY, "true");
      } catch (error) {
        // Ignore storage failures (private mode, blocked, etc.)
      }
      return;
    }
    setRootGateError("Invalid password.");
  };

  // if (!isRootGateUnlocked) {
  //   return (
  //     <React.Fragment>
  //       <div className="account-pages my-5 pt-sm-5">
  //         <div className="container">
  //           <div className="row justify-content-center">
  //             <div className="col-md-8 col-lg-6 col-xl-5">
  //               <div className="card overflow-hidden">
  //                 <div className="bg-primary">
  //                   <div className="row">
  //                     <div className="col-12">
  //                       <div className="text-primary p-4">
  //                         <h5 className="text-white">Enter Password</h5>
  //                         <p className="text-white">Access required to continue</p>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //                 <div className="card-body pt-0">
  //                   <div className="p-2">
  //                     <form className="form-horizontal" onSubmit={handleRootGateSubmit}>
  //                       {rootGateError ? (
  //                         <div className="alert alert-danger">{rootGateError}</div>
  //                       ) : null}
  //                       <div className="mb-3">
  //                         <label className="form-label">Password</label>
  //                         <input
  //                           type="password"
  //                           className="form-control"
  //                           value={rootGateValue}
  //                           onChange={(event) => {
  //                             setRootGateValue(event.target.value);
  //                             if (rootGateError) {
  //                               setRootGateError("");
  //                             }
  //                           }}
  //                           autoFocus
  //                         />
  //                       </div>
  //                       <div className="mt-3 d-grid">
  //                         <button className="btn btn-secondary btn-block" type="submit">
  //                           Continue
  //                         </button>
  //                       </div>
  //                     </form>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </React.Fragment>
  //   );
  // }

  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<Spinner />}>
          <Routes>
            {/* Public routes */}
            {publicRoutes.map((route, idx) => (
              <Route
                key={`pub-${idx}`}
                path={route.path}
                element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              />
            ))}

            {/* Private routes based on role */}
            {role === "admin"
              ? adminRoutes.map((route, idx) => (
                  <Route
                    key={`admin-${idx}`}
                    path={route.path}
                    element={
                      <Authmiddleware>
                        <Layout>{route.component}</Layout>
                      </Authmiddleware>
                    }
                  />
                ))
              : role === "subAdmin"
              ? subAdminRoutes.map((route, idx) => (
                  <Route
                    key={`subAdmin-${idx}`}
                    path={route.path}
                    element={
                      <Authmiddleware>
                        <Layout>{route.component}</Layout>
                      </Authmiddleware>
                    }
                  />
                ))
              : role === "client"
              ? clientRoutes.map((route, idx) => (
                  <Route
                    key={`client-${idx}`}
                    path={route.path}
                    element={
                      <Authmiddleware>
                        <ActionRequiredGuard>
                          <Layout>{route.component}</Layout>
                        </ActionRequiredGuard>
                      </Authmiddleware>
                    }
                  />
                ))
              : workerRoutes.map((route, idx) => (
                  <Route
                    key={`worker-${idx}`}
                    path={route.path}
                    element={
                      <Authmiddleware>
                        <ActionRequiredGuard>
                          <Layout>{route.component}</Layout>
                        </ActionRequiredGuard>
                      </Authmiddleware>
                    }
                  />
                ))}
          </Routes>
        </Suspense>
      </QueryClientProvider>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout
  };
};

export default connect(mapStateToProps, null)(App);
